/** Billing status for a membership — synced from BE EBillingStatus enum */
export enum BillingStatus {
  FREE = 'free',
  PENDING_PAYMENT = 'pending_payment',
  PAID = 'paid',
  OVERDUE = 'overdue',
  LOCKED = 'locked',
  EXEMPT = 'exempt'
}

/** Billing model — how this membership is billed */
export enum BillingModel {
  ORG_PAYS = 'org_pays',
  ATHLETE_PAYS = 'athlete_pays',
  FUNDRAISING = 'fundraising'
}

/** Membership billing summary for admin dashboard */
export interface MembershipBillingSummary {
  membershipId: number
  userId: number
  userName: string
  userEmail: string
  roleId: number
  billingModel: BillingModel
  billingStatus: BillingStatus
  stripeSubscriptionId?: string
  paymentFailedAt?: string
}

/** Stripe Checkout session response */
export interface CheckoutSessionResponse {
  url: string
}

/** Org billing overview for admin */
export interface OrgBillingOverview {
  totalMembers: number
  paidMembers: number
  freeMembers: number
  overdueMembers: number
  lockedMembers: number
  billingModel: BillingModel
  stripeCustomerId?: string
}
